module.exports = __webpack_public_path__ + "static/media/avatar-C_Q.66894b34.png";